import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnSuccess(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  return function onSuccess() {
    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
